// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

import api from '@/api';

export default {
    list(filters = {}) {
        return api.get('/v1/bank-rules', filters);
    },

    view(id) {
        return api.get(`/v1/bank-rules/${id}`);
    },

    create(payload) {
        return api.post('/v1/bank-rules', payload);
    },

    update(id, payload) {
        return api.put(`/v1/bank-rules/${id}`, payload);
    },

    archive(id) {
        return api.put(`/v1/bank-rules/${id}/archive`);
    },

    reorder(orderedIds) {
        return api.put('/v1/bank-rules/reorder', { ordered_ids: orderedIds });
    },

    preview(payload) {
        return api.post('/v1/bank-rules/preview', payload);
    },

    bulkUpdate(ids, action) {
        return api.put('/v1/bank-rules/bulk-update', { ids, action });
    },
};
